import { useCallback } from 'react';
import UsageTracker from '../../../utils/UsageTracker';
import { useLearningContentCardTo } from '../cardsHooks';
import TrackDeprecatedDescription from '../../../components/TrackCard/TrackDeprecatedDescription';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ACInlineContentCard from 'academy-common-lib/components/card/ACInlineContentCard';
import { LearningContentCompletedMessage } from './LearningContentThumbnail';
import LearningContentCardAwardLink from './LearningContentCardAwardLink';
import { CardMenuIcon } from '../../cardMenu';
import { CertificationIcon } from 'foundations-assets';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { Flex } from 'foundations-components/components/Flex';
import ACLearningContentTitle from 'academy-common-lib/features/cards/components/ACLearningContentTitle';
import { ACLearningContentTimeReadout } from 'academy-common-lib/features/cards/components/ACLearningContentTimeReadout';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const ReducedLearningContentCard = ({
  item,
  overviewType,
  position,
  playlistId,
  onItemClick,
  use = 'on-light',
  size = 'small',
  showOverview,
  footer,
  body,
  thumbnailHeader,
  thumbnailUse,
  renderMenu = menu => menu,
  alwaysShowMenu,
  disableLink,
  completionPercentage,
  'data-test-id': dataTestId = 'learning-content-card'
}) => {
  var _lessonType$;
  const {
    id,
    type,
    language,
    name,
    progress,
    previewThumbnailSquareUrl
  } = item;
  const completed = (progress === null || progress === void 0 ? void 0 : progress.status) === 'COMPLETED';
  const {
    itemsCount = 0
  } = item;
  const {
    lessonType
  } = item;
  const {
    completedItemsCount = 0
  } = progress || {};
  const remainingItems = itemsCount - completedItemsCount;
  const to = useLearningContentCardTo({
    item,
    overviewType,
    playlistId,
    showOverview
  });
  const {
    isDeprecated,
    certification,
    deprecationCta,
    duration
  } = item;
  const handleClick = useCallback(() => {
    if (onItemClick) onItemClick(item);
    if (!disableLink) UsageTracker.track('interaction', {
      action: 'content-card-click',
      contentType: type,
      contentId: id,
      appearsIn: overviewType,
      position,
      name,
      style: 'reduced',
      isInProgress: (progress === null || progress === void 0 ? void 0 : progress.status) === 'IN_PROGRESS',
      isCertification: certification,
      playlistId
    });
  }, [onItemClick, item, disableLink, type, id, overviewType, position, name, progress === null || progress === void 0 ? void 0 : progress.status, certification, playlistId]);
  return /*#__PURE__*/_jsx(ACInlineContentCard, {
    completed: completionPercentage ? completionPercentage === 100 : completed,
    completedMessage: /*#__PURE__*/_jsxs(List, {
      inline: true,
      use: "inline-divided",
      wrapChildren: true,
      children: [/*#__PURE__*/_jsx(LearningContentCompletedMessage, {
        type: type
      }), type === 'TRACK' && /*#__PURE__*/_jsx(LearningContentCardAwardLink, {
        trackId: id,
        use: use
      })]
    }),
    "data-test-id": dataTestId,
    description: body,
    disabled: isDeprecated,
    duration: completionPercentage ? 100 : duration || itemsCount,
    endSlot: alwaysShowMenu || !isDeprecated ? /*#__PURE__*/_jsx(View, {
      marginInlineEnd: "300",
      children: renderMenu( /*#__PURE__*/_jsx(CardMenuIcon, {
        item: {
          id,
          language: language,
          type: type
        },
        use: use === 'on-dark' ? 'on-dark-transparent' : 'on-light-transparent'
      }))
    }) : undefined,
    footer: footer || (isDeprecated ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(TrackDeprecatedDescription, {
        compressed: true,
        cta: deprecationCta,
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyComponents.reducedContentCards.notAvailable"
        }),
        trackId: id
      })
    }) : /*#__PURE__*/_jsx(List, {
      use: "inline-divided",
      children: progress === undefined ? /*#__PURE__*/_jsx("span", {
        children: "\xA0"
      }) // take the entire row while progress is loading, so it doesn't flick
      : /*#__PURE__*/_jsxs(_Fragment, {
        children: [(!progress || (progress === null || progress === void 0 ? void 0 : progress.status) === 'NOT_STARTED') && /*#__PURE__*/_jsx(ListItem, {
          children: /*#__PURE__*/_jsxs(Flex, {
            alignItems: "center",
            gap: "100",
            children: [/*#__PURE__*/_jsx(ACLearningContentTitle, {
              certification: certification,
              lessonType: String((_lessonType$ = lessonType === null || lessonType === void 0 ? void 0 : lessonType[0]) !== null && _lessonType$ !== void 0 ? _lessonType$ : ''),
              type: type
            }), certification && /*#__PURE__*/_jsx(CertificationIcon, {
              color: "fill-accent-orange-default",
              size: "600"
            })]
          })
        }), /*#__PURE__*/_jsx(ListItem, {
          children: /*#__PURE__*/_jsx(ACLearningContentTimeReadout, {
            item: item
          })
        })]
      })
    })),
    name: name,
    onClick: handleClick,
    remainingTime: completionPercentage ? 100 - completionPercentage : (progress === null || progress === void 0 ? void 0 : progress.remainingDuration) || remainingItems,
    size: size === 'small' ? 'extra-small' : 'medium',
    thumbnailOverlay: thumbnailHeader,
    thumbnailSrc: previewThumbnailSquareUrl,
    thumbnailUse: thumbnailUse,
    to: disableLink || isDeprecated ? null : to,
    use: use
  });
};
export default ReducedLearningContentCard;